<div class="ui vertical segment">
  <!-- <div
    class="ui label warning-label"
    style="
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
    "
    *ngIf="message"
  >
    <div>{{ message }}</div>
    <button
      *ngIf="redirect_url"
      style="margin-top: 15px"
      class="ui primary button"
    >
      <a href="{{ redirect_url }}" style="color: white">
        Go back to {{ applicationType }} application
      </a>
    </button>
  </div> -->
  <div class="ui label warning-label">
  <span>
    <svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
					stroke="#2C6ECB"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
  </span>

  <span class="text">Please confirm that your Equipment Records are accurate and up-to-date. If
    any information is incorrect, kindly click on the edit icon to make the necessary updates. However, you can send us a chat
    message <a [routerLink]="['/contractor/chat-window']" routerLinkActive="active">here</a> if you
    have any question or feedback.</span>
</div>

<div fxLayout="row" fxLayoutAlign="space-between center">
  <h3 appMargin marginB="0" class="ui primary header">Equipment</h3>
  <div>
    <button
      class="ui medium primary basic dropdown button"
      [disabled]="pending"
      style="padding: 13px 18px; border-radius: 6px;"
      suiDropdown
    >
      <div class="text">Actions</div>
      <i class="dropdown icon"></i>
      <div
        appMargin
        marginT="2"
        class="menu"
        suiDropdownMenu
        appPadding
        paddingX="3"
        style="max-width: 250px; word-break: break-word"
      >
        <a class="item" (click)="downloadTemplate()"
          >Download Equipment <br />Template</a
        >

        <a class="item" (click)="uploader.click()"
          ><input
            #uploadDoc
            type="file"
            #uploader
            accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
            (change)="uploadImage($event)"
            placeholder="Browse for documents"
            onclick="value = null"
            style="display: none"
          />
          Upload Equipment List</a
        >
      </div>
    </button>

    <!-- <button
      [disabled]="pending"
      *isPermitted="{ id: 'EQUIPMENT_MANAGEMENT', action: 'add' }"
      (click)="addEquipment()"
      class="ui tiny primary button"
      style="font-weight: 500"
      appPadding
      paddingY="4"
    >
      Add New Equipment
    </button> -->
  </div>
</div>

<div class="ui divider"></div>


  <div class="ui secondary sub pointing menu">
    <div
      class="ui item"
      [routerLink]="['./official']"
      routerLinkActive="active"
    >
      Official Equipment
      <div class="ui blue label mini circular">{{ officialEquipmentCount }}</div>
    </div>
    <div class="ui item" [routerLink]="['./archive']" routerLinkActive="active">
      Archived Equipment
      <div class="ui blue label mini circular">{{ archivedEquipmentCount }}</div>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
